import React, {FC, useRef, useState} from "react";
import clsx from "clsx";
import {Tooltip, Typography} from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  text: string;
  className?: string;
};

/*
 * One line cut with an ellipsis; a cut text shows in full in a tooltip.
 * `text-overflow` needs a bounded width, so the parent has to cap it — a
 * width-capped block, or a flex row the text shrinks in.
 * It is measured on hover: a rename keeps the box's width, so a resize
 * observer would not notice the text starting (or stopping) to overflow.
 */
const EllipsisText: FC<Props> = ({text, className}) => {
  const classes = useStyles();
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const openIfTruncated = () => {
    const element = textRef.current;
    setIsTooltipOpen(!!element && element.scrollWidth > element.clientWidth);
  };

  return (
    <Tooltip
      open={isTooltipOpen}
      onOpen={openIfTruncated}
      onClose={() => setIsTooltipOpen(false)}
      placement="top-start"
      title={<Typography className={classes.tooltip}>{text}</Typography>}
    >
      <span ref={textRef} className={clsx(classes.text, className)}>
        {text}
      </span>
    </Tooltip>
  );
};

export default EllipsisText;
